module.exports = __webpack_public_path__ + "static/media/label-race.7b508e57.svg";